import React, { useContext, useState, useEffect } from "react";
import { Popover } from '@headlessui/react';

import { ArrowRightIcon } from "@heroicons/react/24/outline"
import { CheckCircleIcon } from "@heroicons/react/24/solid";

import { getLivelli, selezionaLivello, cancellaLivello } from "../services/api";
import { getSubscriptions, deleteSubscription } from '../services/api_subscriptions';

import { AuthContext } from "../contexts/auth"
import { whoami } from "../services/api"
import { calculateTotalCost as baseCalculateTotalCost } from "../services/utils";

import Fetching from "../components/fetching";

import Swal from "sweetalert2"
import Footer from "../components/footer";
import SubscriptionManager from "../components/subscription_manager";
import ModalUpdateSubscription from "../components/subscription_update_modal";
import { Link } from "wouter";
import PopoverComponentCustom from "../components/popover_component";


function getDurationFromNumber(months) {
    if(months == 12)
        return 'year';
    
    return 'month';
}



export function Piano({duration, plan, isActive, style, handleSelectLevel, handleDeleteLevel, currentStatus, level, isLevelActive}) {
    return <>
        {duration == getDurationFromNumber(plan.duration_months) 
            && <>
            <h5 className="my-2 text-2xl font-bold tracking-tight text-gray-900 underline p-4">
                {
                    plan
                        .net_price
                        .toLocaleString(
                            'it-IT',
                            {style: 'currency', currency: 'EUR',}
                        )
                } + IVA
            </h5>
            <div className="mt-auto">
            { isLevelActive && !isActive && currentStatus != 'In prova' &&
                <div className="mb-3">
                    Il tuo piano risulta sottoscritto nella versione <span style={{ textDecoration: 'underline' }}>{duration === 'year' ? 'Mensile' : 'Annuale'}</span>
                </div>
                }
            {   
                !isActive ? (
                <button onClick={() => handleSelectLevel(level)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Seleziona
                    <ArrowRightIcon className="h-5 w-5" />
                </button> ) : (
                <>
                    <p className="mb-3 font-normal text-gray-700 p-4 uppercase">
                        Stato: <span className={`${style.textColor} underline`}>{currentStatus}</span>
                    </p>
                    {/* #TODO: da migliorare condizione su button elimina*/}
                    {/* { currentStatus != 'Cancellato alla fine del periodo' && style.currentStatus !== 'In prova' ? (
                    <button onClick={() => handleDeleteLevel(level)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        Elimina
                        <TrashIcon className="h-5 w-5" />
                    </button>
                ) : null} */}
                </>
            )}
            </div>
            </>
        }
    </>;
};

export default function Livelli() {
    // TODO: si potrebbe spostare direttamente in nvabar?
    const { profile, token, setProfile } = useContext(AuthContext);
    const [levels, setLevels] = React.useState([]);
    const [customerPortal, setCustomerPortal] = useState();
    const [currentLevels, setCurrentLevels] = React.useState([]);
    const [duration, setDuration] = useState('month'); 
    const [loading, setLoading] = React.useState(false);
    const [employeeCount, setEmployeeCount] = useState(profile.employee_with_active_contracts ? profile.employee_with_active_contracts : 1);
    const [selectedBaseProducts, setSelectedBaseProducts] = useState([]);
    const [selectedProProducts, setSelectedProProducts] = useState([]);
    const durationToggleRef = React.useRef(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedPlan, setSelectedPlan] = React.useState(null);
    const [couponCode, setCouponCode] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [activeContractEmployees, setActiveContractEmployees] = useState();
    const [availableEmployees, setAvailableEmployees] = useState();
    const [activeSubscriptionCode, setActiveSubscriptionCode] = useState([]);
    const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [error, setError] = useState(null);
    const [subscriptionTiers, setSubscriptionTiers] = useState({});
    const [isInTrial, setIsInTrial] = useState(false);
    const [mode, setMode] = useState('');
    const [subscriptionId, setSubscriptionId] = useState([]);
    const [selectedPlanUpgrade, setSelectedPlanUpgrade] = useState();

    const isProfileComplete = profile.has_complete_profile;
    const isCompany = profile.customer_type === 'company';

    const nameTrans = {
        "pro year": "consultala_hr_pro_year",
        "pro month": "consultala_hr_pro_month",
        "base year": "consultala_hr_base_year",
        "base month": "consultala_hr_base_month",
    };

    const getTranslatedCodename = (planName) => nameTrans[`${planName.toLowerCase()} ${duration}`];

    const getTier = (planName) => {
        
        const planCodeName = getTranslatedCodename(planName);
        
        const level = levels.find(l => l.codename === planCodeName);
        return level?.tiers || [];
    };


    const durationLabel = {
        'month': 'Mensile',
        'year': 'Annuale',
    }

    const planDetails = {
        base: {
            month: { codename: "consultala_hr_base_month"},
            year: { codename: "consultala_hr_base_year"},
        },
        pro: {
            month: { codename: "consultala_hr_pro_month"},
            year: { codename: "consultala_hr_pro_year"},
        },
    };

    const featuresMapping = {
        base: {
            month: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Gestione Presenze': false,
                'Gestione Turni': false,
                'Gestione Sedi': false,
                'Gestione Responsabile Sedi': false,
                'Autorizzazione Giustificativi': false,
                'Timbrature': false,
                'Avvisi Aziendali': false,
                'Esportazione Dati': false,
                'Rimborsi Spese e Km': false,
            },
            year: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Gestione Presenze': false,
                'Gestione Turni': false,
                'Gestione Sedi': false,
                'Gestione Responsabile Sedi': false,
                'Autorizzazione Giustificativi': false,
                'Timbrature': false,
                'Avvisi Aziendali': false,
                'Esportazione Dati': false,
                'Rimborsi Spese e Km': false,
            },
        },
        pro: {
            month: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Gestione Presenze': true,
                'Gestione Turni': true,
                'Gestione Sedi': true,
                'Gestione Responsabile Sedi': true,
                'Autorizzazione Giustificativi': true,
                'Timbrature': true,
                'Avvisi Aziendali': true,
                'Esportazione Dati': true,
                'Rimborsi Spese e Km': true,
            },
            year: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Gestione Presenze': true,
                'Gestione Turni': true,
                'Gestione Sedi': true,
                'Gestione Responsabile Sedi': true,
                'Timbrature': true,
                'Autorizzazione Giustificativi': true,
                'Avvisi Aziendali': true,
                'Esportazione Dati': true,
                'Rimborsi Spese e Km': true,
            },
        },
    };

    const getStripePriceId = (codename) => levels.find(l => l.codename === codename)?.id;

    const getSubscriptionPlansByDuration = (duration) => {
        return Object.entries(planDetails).map(([planType, details]) => ({
            name: planType.charAt(0).toUpperCase() + planType.slice(1),
            codename: details[duration].codename,
            stripePlanId: getStripePriceId(details[duration].codename),
            features: featuresMapping[planType][duration],
        }));
    };
    
    const products = [
        { name: 'Timbrature', baseDisabled: true },
        { name: 'Scadenze contrattuali', baseDisabled: true },
        { name: 'Visite mediche', baseDisabled: false },
        { name: 'DPI', baseDisabled: false },
        { name: 'Missioni', baseDisabled: false },
    ];
      
    
    const handleDurationToggle = (newDuration) => {
        setDuration(newDuration);
    };

    const refreshProfileAndEmployees = async () => {
        try {
          setLoading(true);
          const updatedProfile = await whoami(token);
      
          if (!updatedProfile) {
            throw new Error("Errore nel recupero del profilo");
          }
      
          setProfile(updatedProfile);
          setActiveContractEmployees(updatedProfile.employee_with_active_contracts);
        } catch (error) {
          console.error("Errore nel recupero del profilo o dei dipendenti attivi:", error);
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: 'Impossibile aggiornare il profilo e i dipendenti attivi.',
            confirmButtonText: 'OK',
          });
        } finally {
          setLoading(false);
        }
    };
      
    const fetchLivelli = async () => {
        try {
            const data = await getLivelli(token);
            setLevels(data.levels);
            setActiveSubscriptionCode(data.subscription);
            setCustomerPortal(data.customer_portal);
            setAvailableEmployees(data.available_employees);
            setIsInTrial(data.is_in_trial);
        } catch (error) {
          console.error("Errore nel recupero dei livelli:", error);
          Swal.fire({
            title: 'Errore',
            text: 'Impossibile recuperare i livelli.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
    };
      
    useEffect(() => {
        if (token) {
          fetchLivelli();
          refreshProfileAndEmployees(); 
        }
    }, [token]);

    const fetchSubscriptionsCompany = async () => {
        setIsLoading(true);
        setError(null);
    
        try {
            const subscriptionsData = await getSubscriptions(token);
            setSubscriptions(subscriptionsData);

            if(subscriptionsData && subscriptionsData.length > 0) {
                setEmployeeCount(isInTrial ? 1 : subscriptionsData[0].quantity);
                setSubscriptionId(subscriptionsData[0].id);
            }          
    
            const getTierActiveSubscription = (planCodeName) => {
                const level = levels.find((l) => l.codename === planCodeName);
                return level?.tiers || [];
            };
    
            const tiersMap = subscriptionsData.reduce((acc, subscription) => {
                const subscriptionName = subscription.plan.code;
                const subscriptionId = subscription.id;
                const tiers = getTierActiveSubscription(subscriptionName);
    
                acc[subscriptionId] = {
                    name: subscriptionName,
                    tiers: tiers,
                };
                return acc;
            }, {});
    
            setSubscriptionTiers(tiersMap);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (token && levels.length > 0) {
            fetchSubscriptionsCompany();
        }
    }, [token, levels]); 
    
    const handleSelectLevel = (plan, employeeCount) => {      
        const codeName = getTranslatedCodename(plan.name);
        const selectedLevel = levels.find(level => level.codename === codeName);     
        const { discounted } = calculateTotalCost(plan);
    
        if (!selectedLevel) {
            Swal.fire({
                icon: 'error',
                title: 'Nessun piano trovato',
                text: 'Nessun piano trovato per la durata selezionata. Contattaci',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
            });
            return;
        }
    
        if (activeSubscriptionCode.length === 0) {
            if (employeeCount < activeContractEmployees) {
                Swal.fire({
                    icon: 'error',
                    title: 'Numero di licenze insufficiente',
                    html: `Hai <strong>${activeContractEmployees}</strong> contratti attivi.<br><br> Non è possibile acquistare un numero inferiore di licenze.`,
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                });
                return;
            }
        }
        
        setSelectedPrice(discounted);
        setSelectedPlan(selectedLevel);
        setCouponCode(couponCode);
        setIsModalOpen(true);
        setMode('newSubscription')
    };
    
    const handleUpgrade = (plan, availableEmployees) => {     
        const codeName = getTranslatedCodename(plan.name);
        const selectedLevel = levels.find(level => level.codename === codeName);     
        const { discounted } = calculateTotalCost(plan);    
        
        if (!selectedLevel) {
            Swal.fire({
                icon: 'error',
                title: 'Nessun piano trovato',
                text: 'Nessun piano trovato per la durata selezionata. Contattaci',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
            });
            return;
        }
    
        if (activeSubscriptionCode.length === 0) {
            if (employeeCount < activeContractEmployees) {
                Swal.fire({
                    icon: 'error',
                    title: 'Numero di licenze insufficiente',
                    html: `Hai <strong>${activeContractEmployees}</strong> contratti attivi.<br><br> Non è possibile acquistare un numero inferiore di licenze.`,
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                });
                return;
            }
        }

        setEmployeeCount(availableEmployees)
        setSelectedPrice(discounted);
        setSelectedPlan(selectedLevel);
        setSelectedPlanUpgrade(selectedLevel.id)
        setIsModalOpen(true);
        setMode('upgradeSubscription');
    };
        
    const handleDeleteSubscription = async (subscriptionId) => {
        const confirmation = await Swal.fire({
            title: 'Conferma eliminazione',
            text: "Stai eliminando il rinnovo automatico della sottoscrizione. Potrai continuare ad utilizzare la piattaforma fino al periodo pagato. Confermi l'eliminazione?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        });
    
        if (confirmation.isConfirmed) {
            try {
                await deleteSubscription(token, subscriptionId);
                Swal.fire({
                    title: 'Eliminazione completata',
                    text: 'La sottoscrizione è stata eliminata correttamente.',
                    icon: 'success',
                });
  
                fetchSubscriptionsCompany(); 
            } catch (error) {
                Swal.fire({
                    title: 'Errore',
                    text: 'Qualcosa è andato storto! Contattaci.',
                    icon: 'error',
                });
            }
        }
    };
    
    const handleOpenModal = (plan) => {
        setSelectedPlan(plan); 
        setIsModalOpen(true); 
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); 
    };

    const handleBack = () => {
        setShowSubscriptionDetails(false);
        fetchSubscriptionsCompany();  
        refreshProfileAndEmployees();
        if (token) {
            fetchLivelli();
        } 
    };

    const handleEmployeeCountChange = (e) => {
        let value = parseInt(e.target.value, 10);
    
        if (isNaN(value)) {
            setEmployeeCount('');
            return;
        }
    
        if (value < 1) {
            setEmployeeCount(1);
        } else if (value > 100) {
            setEmployeeCount(100);
        } else {
            setEmployeeCount(value);
        }
    };

    const handleProductSelect = (productName, planName) => {
        if (planName === 'Base') {
            setSelectedBaseProducts((prevSelected) =>
                prevSelected.includes(productName)
                    ? prevSelected.filter((item) => item !== productName)
                    : [...prevSelected, productName]
            );
        } else if (planName === 'Pro') {
            setSelectedProProducts((prevSelected) =>
                prevSelected.includes(productName)
                    ? prevSelected.filter((item) => item !== productName)
                    : [...prevSelected, productName]
            );
        }
    };

    const calculateTotalCost = (plan) => {
        const tiers = getTier(plan.name);
        return baseCalculateTotalCost(employeeCount, tiers, profile.customer_type)
    };
    
    const handleShowSubscriptionDetails = () => {
        setShowSubscriptionDetails(true);
    }; 

    if(loading)
        return <Fetching />

    // const featureList = Object.keys(subscriptionPlans[0].features);

    const subscriptionPlansToRender = getSubscriptionPlansByDuration(duration);


    // TODO: move template to single file
    return (

        <>
            <PopoverComponentCustom title="Abbonamenti" />

            {isCompany && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                        Il profilo non è completo. <br />
                        Per abilitare l'acquisto di un piano, compila i campi mancanti{' '}
                        <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                        >
                            cliccando qui
                        </Link>
                        </p>
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                {(activeSubscriptionCode && activeSubscriptionCode.length > 0) && (
                    <>
                        {!showSubscriptionDetails && customerPortal && (
                            (profile.can_purchase) && (
                                <div className="mx-auto max-w-7xl px-6 lg:px-8 w-full mt-6">
                                    <div className="border border-gray-100 rounded-lg shadow-lg w-full">
                                        <div className="flex items-center justify-between p-4">
                                            <span className="text-lg font-semibold text-indigo-800">
                                                Gestisci il tuo Abbonamento
                                            </span>
                                            <button 
                                                className="bg-indigo-600 text-white font-bold px-4 py-2 rounded-md"
                                                onClick={handleShowSubscriptionDetails}
                                            >
                                                Visualizza Sottoscrizioni Attive
                                            </button>
                                        </div>
                                        <hr />
                                        <div className="text-lg font-semibold text-indigo-800 p-4">
                                            Licenze dipendenti utilizzate <span className="text-orange-500">{activeContractEmployees}</span> su <span className="text-orange-500">{availableEmployees}</span> disponibili
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </>
                )}

                {showSubscriptionDetails && (
                    <div className="flex-grow h-full">
                        <SubscriptionManager 
                            token={token} 
                            customerPortal={customerPortal} 
                            onBack={handleBack}
                            activeSubscriptionCode={activeSubscriptionCode}
                            activeEmployeesNumber={activeContractEmployees}
                            availableEmployees={availableEmployees}
                            subscriptionDetails={subscriptions}
                            onDelete={handleDeleteSubscription}
                            onUpdateSubscription={handleOpenModal}
                            customerType={profile.customer_type}
                            tiers={subscriptionTiers}
                        />
                    </div>
                )}

                {!showSubscriptionDetails && (
                    <div className="bg-white pb-8 pt-0">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            {(!profile?.can_purchase) ? (
                                <div className="pt-8 min-h-screen">
                            
                                    <div className="bg-gray-50 p-12 rounded-md shadow-md text-center">
        
                                        <p className="mx-auto w-1/2 text-center mb-5 font-bold underline">
                                            L'attuale piano di abbonamento non è gestito da te
                                        </p>
                                        <p className="mx-auto w-1/2 text-center mb-10">
                                            Se desideri iniziare a gestire in autonomia il tuo piano di abbonamento o apportare modifiche alla configurazione attuale, contattaci via email al seguente indirizzo:
                                        </p>
                                        <p className="mx-auto w-1/2 text-center underline italic">
                                            <a href="mailto:supporto@consultala.com" className="text-purple-600 hover:underline">supporto@consultala.com</a>
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <main className="mt-6 pb-8">
                                    <p className="mx-auto max-w-2xl text-center text-md font-medium text-gray-900 pb-6">
                                        Seleziona il piano per la tua azienda e scopri tutte le funzionalità disponibili
                                    </p>
                                    <div className="flex justify-center w-full">
                                        <div className="relative inline-flex items-center w-full shadow-lg">
                                            <button
                                                onClick={() => handleDurationToggle('month')}
                                                className={`flex-1 p-2 text-center rounded-l-md transition-colors ${
                                                    duration === 'month' ? 'bg-indigo-200 text-indigo-800 font-bold' : 'bg-white text-indigo-800 border border-gray-100'
                                                }`}
                                            >
                                                {durationLabel.month}
                                            </button>
                                            <button
                                                onClick={() => handleDurationToggle('year')}
                                                className={`flex-1 p-2 text-center rounded-r-md transition-colors ${
                                                    duration === 'year' ? 'bg-indigo-200 text-indigo-800 font-bold' : 'bg-white text-indigo-800 border border-gray-100'
                                                }`}
                                            >
                                                {durationLabel.year}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-6 overflow-visible relative">
                                        <div className="table w-full">

                                            {/* Tabella dei Piani di abbonamento */}
                                            <table className="w-full table-fixed border-collapse shadow-md">
                                                <thead>
                                                    <tr>
                                                        <th className="w-1/3 text-left text-lg font-semibold text-gray-900"></th>
                                                        {subscriptionPlansToRender.map((plan) => (
                                                            <th
                                                                key={plan.name}
                                                                className={`relative px-4 py-6 text-center text-2xl text-indigo-800 font-bold rounded-t-lg ${
                                                                    plan.name === 'Pro'
                                                                        ? 'bg-indigo-100 border-b border-indigo-300 shadow-lg'
                                                                        : 'bg-gray-50 border-gray-200 rounded-t-lg'
                                                                }`}
                                                            >
                                                                {profile.customer_type === 'consultant' && (
                                                                    <div className="text-sm mb-2 border border-orange-500 text-orange-500 py-1 rounded-2xl bg-orange-50 w-2/3 flex justify-center items-center mx-auto text-center">
                                                                        Promo Consulente -30%
                                                                    </div>
                                                                )}
                                                                Piano {plan.name}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                    
                                                <tbody className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                                                    {Object.keys(subscriptionPlansToRender[0].features).map((feature, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                                                                {feature}
                                                            </td>
                                                            {subscriptionPlansToRender.map((plan) => (
                                                                <td key={plan.codename} className={`text-center px-4 py-3 border ${plan.features[feature] ? 'text-indigo-600 border-gray-200 bg-gray-50' : 'text-gray-400 border-gray-200'}`}>
                                                                    {plan.features[feature] ? <CheckCircleIcon className="inline-block h-5 w-5" /> : '✗'}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            {/* Tabella dei prodotti aggiuntivi */}
                                            {/* <table className="w-full table-fixed border-collapse shadow-md mt-4 rounded-md">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={3} className="bg-indigo-100 mx-auto max-w-2xl text-center text-xl font-semibold text-indigo-800 py-3 rounded-t-md">
                                                            Seleziona i prodotti aggiuntivi
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                                                    {products.map((product, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                                                                {product.name}
                                                            </td>
                                                            <td className="px-4 py-3 text-center border border-gray-200">
                                                                {product.baseDisabled ? (
                                                                    <span className="text-gray-500 text-sm">Non selezionabile</span>
                                                                ) : (
                                                                    <input
                                                                        type="checkbox"
                                                                        className="rounded-lg border-indigo-500 text-indigo-600 focus:ring-indigo-600"
                                                                        onChange={() => handleProductSelect(product.name, 'Base')}
                                                                        checked={selectedBaseProducts.includes(product.name)}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td className="px-4 py-3 text-center border border-gray-200">
                                                                <input
                                                                    type="checkbox"
                                                                    className="rounded-lg border-indigo-500 text-indigo-600 focus:ring-indigo-600"
                                                                    onChange={() => handleProductSelect(product.name, 'Pro')}
                                                                    checked={selectedProProducts.includes(product.name)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table> */}


                                            {/* Tabella per il calcolo del costo */}
                                            <table className="w-full table-fixed border-collapse shadow-md mt-4">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={3} className="bg-indigo-100 mx-auto max-w-2xl text-center text-xl font-semibold text-indigo-800 py-3 rounded-t-md">
                                                            Calcola il costo e scegli il tuo piano
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                                                    <tr>
                                                        <td className="px-4 py-4 text-left text-sm font-medium text-gray-900 border border-gray-200 text-indigo-800 font-semibold">
                                                            {profile?.employee_with_active_contracts > 0 && (
                                                                <div>Il numero attuale di dipendenti attivi è {profile?.employee_with_active_contracts}</div>
                                                            )}
                                                            <input
                                                                type="number"
                                                                min={1}
                                                                max="100"
                                                                step="1"
                                                                value={employeeCount}
                                                                onChange={handleEmployeeCountChange}
                                                                className="rounded-md border-gray-200 w-full mt-3 focus:border-indigo-800 focus:ring-indigo-800"
                                                                disabled={activeSubscriptionCode.length > 0 && !isInTrial}
                                                                onKeyDown={(e) => {
                                                                    const nextValue = parseInt(e.target.value + e.key, 10);
                                                                    if (!isNaN(nextValue) && nextValue > 100) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />
                                                            <div className="pt-2">Inserisci il numero dei dipendenti per calcolare il costo.</div>
                                                            <div>Per un numero di dipendenti maggiore di 100, contattaci</div>
                                                        </td>
                                                        {subscriptionPlansToRender.map((plan) => {
                                                            const { original, discounted } = calculateTotalCost(plan);

                                                            const isCurrentPlan = activeSubscriptionCode?.includes(plan?.stripePlanId);

                                                            return (
                                                                <td key={plan.name} className="px-4 py-4 text-center border border-gray-200 text-indigo-800 font-semibold text-md">
                                                                    {profile.customer_type === 'consultant' ? (
                                                                        <>
                                                                            <div className="line-through text-gray-500">€ {original} / {duration === 'year' ? 'anno' : 'mese'} + IVA</div>
                                                                            <div className="flex items-center justify-center mt-2">
                                                                                <div className="bg-orange-50 text-orange-500 font-semibold rounded-full p-2 flex items-center justify-center w-14 h-14 mr-2">
                                                                                    -30%
                                                                                </div>
                                                                                <div className="text-indigo-800">
                                                                                    € {discounted} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div>€ {original} / {duration === 'year' ? 'anno' : 'mese'} + IVA</div>
                                                                    )}
                                                                    <div className="items-center text-center justify-center flex mt-3">
                                                                        {(activeSubscriptionCode && activeSubscriptionCode.length > 0 && !isInTrial) ? (
                                                                            isCurrentPlan ? (
                                                                                <span className="text-md font-medium text-gray-900">Questa è la tua sottoscrizione</span>
                                                                            ) : (
                                                                                <button
                                                                                    className="bg-indigo-600 hover:bg-indigo-500 text-white py-1 px-4 rounded"
                                                                                    onClick={() => handleUpgrade(plan, employeeCount, 'upgradeSubscription')}
                                                                                >
                                                                                    Aggiorna Sottoscrizione
                                                                                </button>
                                                                            )
                                                                        ) : (
                                                                            <button
                                                                                className={`py-1 px-4 rounded text-white ${isCompany && !isProfileComplete ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'}`}
                                                                                onClick={() => handleSelectLevel(plan, employeeCount, 'newSubscription')}
                                                                                disabled={isCompany && !isProfileComplete}
                                                                            >
                                                                                Scegli
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    {(isCompany && !isProfileComplete) && (
                                                                        <div className="w-full">
                                                                            <div className="bg-orange-100 text-orange-600 p-4 mt-2 rounded-md">
                                                                                <p className="text-center text-sm font-semibold">
                                                                                Il profilo non è completo. <br />
                                                                                Per abilitare l'acquisto di un piano, compila i campi mancanti{' '}
                                                                                <Link
                                                                                    to="/profilo/fatturazione"
                                                                                    className="text-indigo-600 hover:text-indigo-800 underline"
                                                                                >
                                                                                    cliccando qui
                                                                                </Link>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Icona del piano Pro */}
                                        {subscriptionPlansToRender.map((plan) => (
                                            plan.name === 'Pro' && (
                                                <div
                                                    key={plan.name}
                                                    style={{
                                                        zIndex: '5',
                                                        position: 'absolute',
                                                        top: '-30px',
                                                        right: '-40px'
                                                    }}
                                                >
                                                    <SvgBestChoice />
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </main>

                            )}
                        </div>
                    </div>
                )}
                <div className="align-bottom">
                    <Footer />
                </div>
            </div>


            {isModalOpen && (
                <ModalUpdateSubscription
                    mode={mode}
                    selectedPlan={selectedPlan}
                    employeeCount={employeeCount}
                    duration={duration}
                    selectedPrice={selectedPrice}
                    onClose={handleCloseModal}
                    token={token}
                    subscriptionIdtoUpgrade={subscriptionId}
                    planUpgrade={selectedPlanUpgrade}
                />
            )}
        </>
    )
}

const SvgBestChoice = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="125"
            height="125"
            viewBox="200 200 410 410"
            preserveAspectRatio="xMidYMid meet"
            className="inline-block ml-2"
        >
            <defs>
                <clipPath id="clip-path-id">
                    <path d="M 284.917969 243 L 524.917969 243 L 524.917969 567 L 284.917969 567 Z" />
                </clipPath>
            </defs>
            <g clipPath="url(#clip-path-id)">
                <path
                    fill="#3730a3"
                    d="M 292.820312 345.964844 C 288.949219 351.261719 284.945312 356.742188 284.945312 363.054688 C 284.945312 369.371094 288.949219 374.851562 292.820312 380.148438 C 295.644531 384.015625 298.3125 387.667969 299.308594 391.382812 C 300.363281 395.320312 299.851562 400.167969 299.351562 404.859375 C 298.675781 411.257812 297.976562 417.871094 300.996094 423.09375 C 304.0625 428.398438 310.183594 431.113281 316.101562 433.738281 C 318.066406 434.605469 320.078125 435.507812 321.941406 436.484375 L 290.695312 534.839844 C 290.503906 535.449219 290.648438 536.113281 291.082031 536.582031 C 291.511719 537.050781 292.164062 537.253906 292.78125 537.113281 L 333.574219 527.855469 L 359.339844 566.230469 C 359.671875 566.726562 360.230469 567.015625 360.816406 567.015625 C 360.898438 567.015625 360.984375 567.011719 361.066406 567 C 361.742188 566.902344 362.304688 566.425781 362.511719 565.777344 L 390.667969 477.214844 C 395.417969 480.550781 399.917969 483.109375 404.996094 483.109375 C 410.125 483.109375 414.609375 480.546875 419.332031 477.207031 L 447.46875 565.777344 C 447.675781 566.425781 448.238281 566.902344 448.914062 567 C 448.996094 567.011719 449.082031 567.019531 449.164062 567.019531 C 449.75 567.019531 450.308594 566.726562 450.640625 566.230469 L 476.40625 527.859375 L 517.199219 537.113281 C 517.816406 537.253906 518.46875 537.050781 518.902344 536.582031 C 519.332031 536.113281 519.476562 535.449219 519.285156 534.84375 L 488.042969 436.488281 C 489.898438 435.511719 491.910156 434.609375 493.878906 433.738281 C 499.796875 431.113281 505.917969 428.398438 508.980469 423.097656 C 512 417.878906 511.304688 411.273438 510.632812 404.878906 C 510.136719 400.183594 509.628906 395.328125 510.6875 391.386719 C 510.6875 391.386719 510.6875 391.386719 510.6875 391.382812 C 511.679688 387.660156 514.347656 384.007812 517.171875 380.140625 C 521.039062 374.84375 525.035156 369.367188 525.035156 363.058594 C 525.035156 356.75 521.035156 351.273438 517.171875 345.976562 C 514.347656 342.109375 511.679688 338.457031 510.6875 334.730469 C 509.625 330.789062 510.136719 325.933594 510.632812 321.238281 C 511.304688 314.84375 512 308.234375 508.980469 303.019531 C 505.90625 297.707031 499.765625 294.992188 493.828125 292.363281 C 489.367188 290.390625 485.152344 288.527344 482.34375 285.71875 C 479.535156 282.902344 477.671875 278.691406 475.699219 274.230469 C 473.070312 268.296875 470.355469 262.15625 465.035156 259.078125 C 459.804688 256.058594 453.183594 256.753906 446.78125 257.421875 C 442.09375 257.914062 437.246094 258.421875 433.308594 257.371094 C 429.59375 256.378906 425.945312 253.710938 422.085938 250.886719 C 416.789062 247.007812 411.3125 243 405 243 C 398.691406 243 393.214844 247.003906 387.921875 250.875 C 384.050781 253.699219 380.398438 256.375 376.671875 257.367188 C 372.734375 258.417969 367.882812 257.910156 363.199219 257.417969 C 356.796875 256.746094 350.179688 256.050781 344.960938 259.074219 C 339.636719 262.148438 336.921875 268.289062 334.296875 274.21875 C 332.320312 278.679688 330.457031 282.894531 327.640625 285.710938 C 324.828125 288.523438 320.617188 290.382812 316.160156 292.359375 C 310.230469 294.984375 304.09375 297.703125 301.019531 303.015625 C 297.984375 308.238281 298.683594 314.859375 299.355469 321.265625 C 299.851562 325.953125 300.359375 330.792969 299.308594 334.726562 C 298.3125 338.449219 295.644531 342.097656 292.820312 345.964844 Z"
                />
            </g>
            <text
                x="98%"
                y="85%"
                textAnchor="middle"
                fill="#ffffff"
                fontWeight="bold"
                fontSize="25"
            >
                SCELTA PIÙ
            </text>
            <text
                x="98%"
                y="95%"
                textAnchor="middle"
                fill="#ffffff"
                fontWeight="bold"
                fontSize="25"
            >
                POPOLARE
            </text>
        </svg>
    );
};
